<customer-portal-app-navbar></customer-portal-app-navbar>
<customer-portal-app-navbar-second></customer-portal-app-navbar-second>
<customer-portal-app-revolution-vehicle-gas-prices></customer-portal-app-revolution-vehicle-gas-prices>
<customer-portal-footer-container></customer-portal-footer-container>
